import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  cell: {
    padding: '10px 15px',
    '&:nth-child(2n)': {
      background: '#eaeaea',
    },
  },
  addonTitle: {
    margin: 0,
    padding: 0,
    marginBottom: 20,
    fontSize: 16,
    fontWeight: 400,
    color: theme.custom.darkBlue,
    textAlign: 'center',
  },
  title: {
    margin: 0,
    marginBottom: 15,
    padding: 0,
    fontSize: 16,
    color: theme.custom.darkBlue,
  },
  amount: {
    margin: 0,
    padding: 0,
    fontSize: 20,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  amountRed: {
    color: theme.custom.warning,
  },
  commentsSection: {
    marginTop: 25,
  },
  commentScroll: {
    maxHeight: 225,
    overflow: 'auto',
  },
  comment: {
    margin: 0,
    fontSize: 14,
    color: theme.custom.darkBlue,
    whiteSpace: 'pre-wrap',
  },
}));
